var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import angular from 'angular';
import { Directive } from 'angular-ts-decorators';
let ExpressionSwitchWhenDirective = class ExpressionSwitchWhenDirective {
};
ExpressionSwitchWhenDirective = __decorate([
    Directive({
        selector: 'expression-switch-when',
        require: '^ngSwitch',
        priority: 1200,
        transclude: 'element',
        link: function (scope, element, attrs, ctrl, $transclude) {
            if (!ctrl) {
                throw new TypeError(`'expression-switch-when' can only be used inside an 'ng-switch' directive.`);
            }
            let caseStms = scope.$eval(attrs.expressionSwitchWhen);
            caseStms = angular.isArray(caseStms) ? caseStms : [caseStms];
            angular.forEach(caseStms, function (caseStm) {
                caseStm = '!' + caseStm;
                ctrl.cases[caseStm] = ctrl.cases[caseStm] || [];
                ctrl.cases[caseStm].push({ transclude: $transclude, element: element });
            });
        },
    })
], ExpressionSwitchWhenDirective);
export { ExpressionSwitchWhenDirective };
